<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4" sm="8">
        <v-card class="mx-auto">
          <v-container>
            <v-card-title>
              <v-layout align-center justify-center>
                <v-img contain max-width="200" src="@/assets/securating_logo.png" />
              </v-layout>
              <div class="sr-securating-slogan">
                <b>{{ $t("login.go.me") }}</b> /
                <a
                  :title="$t('login.go.access_title') + ' ' + $t('login.go.manager')"
                  href="https://manager.securating.com"
                  ><i>{{ $t("login.go.access") + " " + $t("login.go.manager") }}</i></a
                >
              </div>
            </v-card-title>

            <v-card-title>
              {{ $t("login.title") + " " + $t("login.go.me") }}
            </v-card-title>

            <!-- Login form -->
            <v-card-text>
              <Form ref="login" :callback="login">
                <FormField
                  v-model="email"
                  i18n="login.form.email.label"
                  input-type="text"
                  place-holder=" "
                  rules="required"
                />
                <FormField
                  v-model="password"
                  :input-type="showPassword ? 'text' : 'password'"
                  i18n="login.form.password.label"
                  place-holder=" "
                  rules="required"
                >
                  <template #append>
                    <v-icon v-if="showPassword" small @click="showPassword = false">fa-eye</v-icon>
                    <v-icon v-else small @click="showPassword = true">fa-eye-slash</v-icon>
                  </template>
                </FormField>

                <div class="mb-2">
                  <router-link to="/registration">
                    {{ $t("login.form.registration") }}
                  </router-link>
                  ,
                  <router-link to="/recover" class="ml-1">
                    {{ $t("login.form.recover") }}
                  </router-link>
                </div>

                <Captcha @verify="captchaResolved = true"></Captcha>

                <v-btn
                  :disabled="!captchaResolved"
                  block
                  class="mt-4 primary"
                  type="submit"
                  @click="$refs.login.validate()"
                >
                  {{ $t("login.submit") }}
                </v-btn>
              </Form>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Types } from "@/store/modules/auth"
import Captcha from "@/components/common/Form/Captcha"
import { Types as TypesSnackbar } from "@/store/modules/snackbar"

export default {
  name: "Login",
  components: {
    Captcha,
  },
  data: () => ({
    email: "",
    password: "",
    showPassword: false,
    captchaResolved: false,
  }),
  methods: {
    login() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(Types.actions.AUTH_LOGIN, {
            email: this.email,
            password: encodeURIComponent(window.btoa(this.password)),
            pro: false,
          })
          .then(() => {
            this.$router.push("/")
            resolve()
          })
          .catch(() => {
            this.password = ""
            this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
              lines: this.$t("login.error"),
              config: { timeout: 1000 * 6, color: "error" },
            })
            reject()
          })
      })
    },
  },
}
</script>
